import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=071f340a&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=ts"
export * from "./Signature.vue?vue&type=script&lang=ts"
import style0 from "./Signature.vue?vue&type=style&index=0&id=071f340a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f340a",
  null
  
)

export default component.exports